import { DATABASE } from "icons";
import { usePermissions } from "contexts/permission";
import { NavItem } from "@/components/item";
import { NavSubItem } from "@/components/sub-item";

export function MasterData() {
  const permissions = usePermissions();

  return (
    <NavItem
      title="Master Data"
      icon={DATABASE}
      url="/master-data"
      matchExact={true}
    >
      <NavSubItem title="Tech Stack" url={`/master-data/tech-stack`} />
      <NavSubItem title="Tools" url={`/master-data/tools`} />
    </NavItem>
  );
}
